    const term = require('terminal-kit').terminal;

    const success = (componentName, pageID) => {
        term("\n")
        term().green("✅ ")
        term(`${componentName} `);
        term().underline.magenta(pageID)
        term("\n")
    }
    const error = (componentName, pageID) => {
        term("\n")
        term().red("🟥 ")
        term(`${componentName} `);
        term().underline.magenta(pageID)
        term("\n")
    }
    module.exports = {
        success: success,
        error: error
    }
